/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect } from 'react'
import {
	InputComponent,
	SelectComponent,
	SelectWithOther,
	SelectComponentProps,
	i18n,
} from 'LibNeo'
import {
	ADDRESS_TYPE,
	DATA_FIELDS_WITH_TYPE,
	DEPENDENT_ADDRESS_FIELDS,
	DEPENDENT_AREA_FIELDS,
	DEPENDENT_FIAS_FIELDS,
	MAX_LENGHT_FIELD,
	TYPE_SELECT_FIELD,
} from 'Constants/Address.constants'
import { FieldNames } from 'Constants/FieldNames'

import translate from 'Src/locale/ru'
import { getOptionsSelect } from 'Helpers'
import { AddressSuggest } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { validateDependentField, Validators } from 'Modules'
import { FormBlock, Half } from './AdressEditStyled'

const { errors } = translate

export type AddressEditSelectProps = SelectComponentProps & {
	inputPlaceHolder: string
	disabled?: boolean
	field: FieldNames
	disableInput?: boolean
	initialData: AddressSuggest
	saveAddress?: Callback
	typeAddress?: ADDRESS_TYPE
}

export const AddressEditSelect: FC<AddressEditSelectProps> = (props) => {
	const {
		field,
		disabled,
		inputPlaceHolder,
		disableInput,
		initialData,
		form,
		saveAddress,
		label,
		typeAddress,
		...other
	} = props

	const { getFieldValue, setFields, validateFields } = form
	const DATA_FIELDS = DATA_FIELDS_WITH_TYPE(typeAddress)
	const dataField = DATA_FIELDS[field]
	const fieldType = dataField.field_type
	const fieldRules = []
	const fieldTypeRules = []
	const isOther = dataField?.options_type === TYPE_SELECT_FIELD.OTHER

	useEffect(() => {
		setFields({
			[fieldType]: {
				value: initialData?.[fieldType] || undefined,
				touched: true,
			},
			[field]: {
				value: initialData?.[field] || undefined,
				touched: true,
			},
		})
	}, [initialData])

	useEffect(() => {
		setFields({
			[fieldType]: {
				value: getFieldValue(fieldType),
				touched: true,
			},
			[field]: {
				value: getFieldValue(field),
				touched: true,
			},
		})
		if (DEPENDENT_FIAS_FIELDS?.includes(field)) {
			if (!getFieldValue(fieldType) && getFieldValue(field)) {
				fieldTypeRules.push({
					validator: validateDependentField(fieldType, errors?.[`${field}.type`]),
				})
				validateFields([fieldType])
			}
		}

		if (DEPENDENT_FIAS_FIELDS?.includes(fieldType)) {
			if (!getFieldValue(field) && getFieldValue(fieldType)) {
				fieldRules.push({
					validator: validateDependentField(field, errors?.[`${field}.number`]),
				})
				validateFields([field])
			}
		}
	}, [getFieldValue(fieldType), getFieldValue(field)])

	const city = getFieldValue(FieldNames.CITY)
	const cityTypeFull = getFieldValue(FieldNames.CITY_TYPE_FULL)
	const oktmoArea = getFieldValue(FieldNames.OKTMO_AREA)
	const oktmoAreaType = getFieldValue(FieldNames.OKTMO_AREA_TYPE)
	const settlement = getFieldValue(FieldNames.SETTLEMENT)
	const settlementTypeFull = getFieldValue(FieldNames.SETTLEMENT_TYPE_FULL)

	useEffect(() => {
		if (DEPENDENT_AREA_FIELDS?.includes(field) && DEPENDENT_AREA_FIELDS?.includes(fieldType)) {
			if (
				!city &&
				!cityTypeFull &&
				!oktmoArea &&
				!oktmoAreaType &&
				!settlement &&
				!settlementTypeFull
			) {
				setFields({
					[fieldType]: {
						value: getFieldValue(fieldType),
						touched: true,
					},
					[field]: {
						value: getFieldValue(field),
						touched: true,
					},
				})
				fieldRules.push({
					validator: validateDependentField(
						FieldNames.CITY_TYPE_FULL,
						errors?.['city_name.is_required']
					),
				})
				fieldTypeRules.push({
					validator: validateDependentField(FieldNames.CITY, errors?.['city.is_required']),
				})
				validateFields([FieldNames.CITY, FieldNames.CITY_TYPE_FULL])
			}
		}

		if (DEPENDENT_AREA_FIELDS?.includes(field)) {
			setFields({
				[fieldType]: {
					value: getFieldValue(fieldType),
					touched: true,
				},
			})
			if (!getFieldValue(fieldType) && getFieldValue(field)) {
				fieldTypeRules.push({
					validator: validateDependentField(fieldType, errors?.[`${field}.type`]),
				})
				validateFields([fieldType])
			}
		}

		if (DEPENDENT_AREA_FIELDS?.includes(fieldType)) {
			setFields({
				[field]: {
					value: getFieldValue(field),
					touched: true,
				},
			})
			if (!getFieldValue(field) && getFieldValue(fieldType)) {
				fieldRules.push({
					validator: validateDependentField(field, errors?.[`${field}.name`]),
				})
				validateFields([field])
			}
		}
	}, [city, cityTypeFull, oktmoArea, oktmoAreaType, settlement, settlementTypeFull])

	const house = getFieldValue(FieldNames.HOUSE)
	const houseTypeFull = getFieldValue(FieldNames.HOUSE_TYPE_FULL)
	const building = getFieldValue(FieldNames.BUILDING)
	const buildingTypeFull = getFieldValue(FieldNames.BUILDING_TYPE_FULL)
	const block = getFieldValue(FieldNames.BLOCK)
	const blockTypeFull = getFieldValue(FieldNames.BLOCK_TYPE_FULL)

	useEffect(() => {
		if (
			DEPENDENT_ADDRESS_FIELDS?.includes(field) &&
			DEPENDENT_ADDRESS_FIELDS?.includes(fieldType)
		) {
			if (!house && !houseTypeFull && !building && !buildingTypeFull && !block && !blockTypeFull) {
				setFields({
					[fieldType]: {
						value: getFieldValue(fieldType),
						touched: true,
					},
					[field]: {
						value: getFieldValue(field),
						touched: true,
					},
				})
				fieldRules.push({
					validator: validateDependentField(
						FieldNames.HOUSE_TYPE_FULL,
						errors?.['house.number.is_required']
					),
				})
				fieldTypeRules.push({
					validator: validateDependentField(FieldNames.HOUSE, errors?.['address.is_required']),
				})
				validateFields([FieldNames.HOUSE, FieldNames.HOUSE_TYPE_FULL])
			}
		}

		if (DEPENDENT_ADDRESS_FIELDS?.includes(field)) {
			setFields({
				[fieldType]: {
					value: getFieldValue(fieldType),
					touched: true,
				},
			})
			if (!getFieldValue(fieldType) && getFieldValue(field)) {
				fieldTypeRules.push({
					validator: validateDependentField(fieldType, errors?.[`${field}.type`]),
				})
				validateFields([fieldType])
			}
		}

		if (DEPENDENT_ADDRESS_FIELDS?.includes(fieldType)) {
			setFields({
				[field]: {
					value: getFieldValue(field),
					touched: true,
				},
			})
			if (!getFieldValue(field) && getFieldValue(fieldType)) {
				fieldRules.push({
					validator: validateDependentField(field, errors?.[`${field}.number`]),
				})
				validateFields([field])
			}
		}
	}, [block, blockTypeFull, building, buildingTypeFull, house, houseTypeFull])

	if (MAX_LENGHT_FIELD?.[field])
		fieldRules.push({
			validator: Validators.checkMaxLength({ payload: { max: MAX_LENGHT_FIELD[field] } }),
		})

	if (MAX_LENGHT_FIELD?.[fieldType])
		fieldTypeRules.push({
			validator: Validators.checkMaxLength({ payload: { max: MAX_LENGHT_FIELD[fieldType] } }),
		})

	return (
		<FormBlock bottom={12}>
			<Half withSpacing>
				{isOther ? (
					<SelectWithOther
						label={label}
						items={dataField.options}
						placeholder={other.placeholder ?? dataField.name_type}
						fieldOptions={{
							initialValue: initialData?.[fieldType] || undefined,
							rules: fieldTypeRules,
						}}
						fieldName={fieldType}
						showSearch
						form={form}
						filterOption
						disabled={disabled}
						onChange={(value) => saveAddress?.(value, fieldType)}
					/>
				) : (
					<SelectComponent
						label={label}
						items={
							dataField?.options_type === TYPE_SELECT_FIELD.SELECT
								? getOptionsSelect(dataField.options)
								: dataField.options
						}
						placeholder={other.placeholder ?? dataField.name_type}
						fieldOptions={{
							initialValue: initialData?.[fieldType] || undefined,
							rules: fieldTypeRules,
						}}
						fieldName={fieldType}
						showSearch
						form={form}
						filterOption
						disabled={disabled}
						onChange={(value) => saveAddress?.(value, fieldType)}
					/>
				)}
			</Half>
			<Half>
				<InputComponent
					placeholder={disableInput ? i18n('common.empty') : inputPlaceHolder}
					onChange={(value) => saveAddress?.(value, field)}
					disabled={disabled || disableInput}
					label={label ? ' ' : undefined}
					fieldName={field}
					fieldOptions={{
						initialValue: initialData?.[field] || undefined,
						rules: fieldRules,
					}}
					form={form}
				/>
			</Half>
		</FormBlock>
	)
}
